import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button';
import { Box } from '@/layout';
import { Modal } from '@mui/material';

import { ModalActions, ModalForm, ModalTitle, ModalNotice } from '../style';
import { errorHandler, successHandler } from '@/utils/toastHandler';
import { Close } from '@/components/Icon';
import { deleteFile, deleteFolder } from '@/api/document.api';

interface DeleteConfirmProps {
  document_id: number;
  show: boolean;
  setDeleteModal: (show: boolean) => void;
  getDocuments: (id: number | null) => void;
  currentFolderId: number | null;
  type: string
}

const DeleteConfirm = ({ document_id, show, setDeleteModal, getDocuments, currentFolderId, type }: DeleteConfirmProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  const { handleSubmit } = useForm<{ id: string }>();

  const onSubmit = handleSubmit(async () => {
    if (!document_id) return;

    if (type === 'folder') {
      try {
        const res = (await deleteFolder(document_id)).data;

        if (res.success) {
          getDocuments(currentFolderId);
          successHandler(t('success.delete'));
          setDeleteModal(false);
        }
      } catch (error) {
        errorHandler(t('error.server'));
      }
    } else {
      try {
        const res = (await deleteFile(document_id)).data;

        if (res.success) {
          getDocuments(currentFolderId);
          successHandler(t('success.delete'));
          setDeleteModal(false);
        }
      } catch (error) {
        errorHandler(t('error.server'));
      }
    }
  });

  return (
    <Modal
      open={show}
      onClose={() => setDeleteModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalForm onSubmit={onSubmit}>
        <Close.ButtonClose
          type="button"
          onClick={() => {
            setDeleteModal(false);
          }}
        >
          <Close.CloseSVG />
        </Close.ButtonClose>
        {
          type === 'folder' ? (
            <>
              <ModalTitle>{t('pages.docLibrary.modal.deleteFolder.title')}</ModalTitle>
              <ModalNotice>{t('pages.docLibrary.modal.deleteFolder.subTitle')}</ModalNotice>
            </>)
            : (
            <>
              <ModalTitle>{t('pages.docLibrary.modal.delete.title')}</ModalTitle>
              <ModalNotice>{t('pages.docLibrary.modal.delete.subTitle')}</ModalNotice>
            </>
            )
        }

        <ModalActions>
          <Button type="submit" size={'lg'} variant={'danger'} rounded={false}>
            {t('buttons.delete')}
          </Button>
          <Button
            type="button"
            size={'lg'}
            variant={'primary-invert'}
            color="primary"
            onClick={() => setDeleteModal(false)}
            style={{ textDecoration: 'underline' }}
          >
            {t('buttons.back')}
          </Button>
        </ModalActions>
      </ModalForm>
    </Modal>
  );
};

export default DeleteConfirm;
